const createBCPOLabels = (wrapper) => {
  const variantOptionElements = wrapper.querySelectorAll('.bcpo-image-parent')
  variantOptionElements.forEach((variant, index) => {
    const { compare_at_price, price } = bcpo_product.variants[index]
    if (price < compare_at_price) {
      const percentOff = Math.floor(((compare_at_price - price) * 100) / compare_at_price)
      const html = `<div class="discount-circle">
        <span>${percentOff}%</span>
      </div>`
      variant.insertAdjacentHTML('beforeend', html)
    }
  });
}

const callback = (mutationList) => {
  for (const mutation of mutationList) {
    if (mutation.removedNodes.length > 0) {
      if (mutation.removedNodes[0].classList.contains('variant-wrapper')) {
        observer.disconnect()
        const bcpoSelectWrapper = document.querySelector('#bcpo-select-option-0')
        if (bcpoSelectWrapper != null) {
          createBCPOLabels(bcpoSelectWrapper)
        }
      }
    }
  }
}

const variantWrapper = document.querySelector('[data-product-blocks]')
const observer = new MutationObserver(callback);
observer.observe(variantWrapper, { childList: true, subtree: true });

setTimeout(() => {
  const bcpoSelectWrapper = document.querySelector('#bcpo-select-option-0')
  if (bcpoSelectWrapper != null) {
    createBCPOLabels(bcpoSelectWrapper)
  }
}, 2000)